import { PhoneInTalkIcon } from './PhoneInTalkIcon';

/**
 * author: Google
 * id F9BA7066-C1F8-4B19-9860-37BDCEB6F11C
 * name phone-in-talk
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/phone-in-talk.svg
 * tags
 * - Cellphone / Phone 
 */
export const TelephoneInTalkIcon = PhoneInTalkIcon;
export default TelephoneInTalkIcon